import "./HeaderTitle.css";

function HeaderTitle() {
  return (
    <div className="title-container">
      <div className="title-icon material-icons">nightlight_round</div>
      <div className="title">Rahat Maqsood Clinic</div>
    </div>
  );
}

export default HeaderTitle;
